import App from './modules/app'

$(window).on('load', ()=>{
  var app = new App()
})
